(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/shared/components/error-message.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/shared/components/error-message.js');

'use strict';

const {
  InlineMessage
} = svs.arena.shared.components;
const ErrorMessage = _ref => {
  let {
    actions,
    header,
    icon,
    text
  } = _ref;
  return React.createElement(InlineMessage, {
    actions: actions,
    header: header,
    icon: icon,
    isError: true,
    text: text
  });
};
svs.arena.shared.components.ErrorMessage = ErrorMessage;

 })(window);